// extracted by mini-css-extract-plugin
module.exports = {"infoBar":"postView_infoBar__DIxuG","codeblock":"postView_codeblock__1-3MH"};